// removed by extract-text-webpack-plugin
module.exports = {"icon":"qempo_SavedAddresses_icon-2izSZGY","contentWrapper":"qempo_SavedAddresses_contentWrapper-2sd__kx","boxesWrap":"qempo_SavedAddresses_boxesWrap-LkworYW","box":"qempo_SavedAddresses_box-1E7GZw1","name":"qempo_SavedAddresses_name-31b51nP","dotsButton":"qempo_SavedAddresses_dotsButton-2w2vexL","firstBox":"qempo_SavedAddresses_firstBox-CFON1jg","iconContainer":"qempo_SavedAddresses_iconContainer-77XJES_"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/preferences/saved-addresses/components/SavedAddresses.scss
// module id = 1391
// module chunks = 0